import React from 'react'
import PropTypes from 'prop-types'

export default function FlagButton({ text, imageUrl, ...rest }) {
  return (
    <a
      {...rest}
      aria-label={text}
      title={text}
      data-pa-click="FooterFlag-Link"
      style={{
        backgroundImage: `url(${
          imageUrl ||
          'https://www.paypalobjects.com/webstatic/mktg/icons/sprite_countries_flag4.png'
        })`,
      }}
    >
      {text}
    </a>
  )
}

FlagButton.propTypes = {
  text: PropTypes.string,
  imageUrl: PropTypes.string,
}
